// Vendor
import { useI18n } from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';

export default {
    name: "classifica",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data(){
        return {
            images: [
                {
                    "pid": "111",
                    "imgPath": "2022/111.jpg",
                    "selected": false
                },
                {
                    "pid": "138",
                    "imgPath": "2022/138.jpg",
                    "selected": false
                },
                {
                    "pid": "938",
                    "imgPath": "2022/938.jpg",
                    "selected": false
                },
                {
                    "pid": "944",
                    "imgPath": "2022/944.jpg",
                    "selected": false
                },
                {
                    "pid": "981",
                    "imgPath": "2022/981.jpg",
                    "selected": false
                },
                {
                    "pid": "1029",
                    "imgPath": "2022/1029.jpg",
                    "selected": false
                },
                {
                    "pid": "1876",
                    "imgPath": "2022/1876.jpg",
                    "selected": false
                },
                {
                    "pid": "2027",
                    "imgPath": "2022/2027.jpg",
                    "selected": false
                },
                {
                    "pid": "2470",
                    "imgPath": "2022/2470.jpg",
                    "selected": false
                },
                {
                    "pid": "2471",
                    "imgPath": "2022/2471.jpg",
                    "selected": false
                },
                {
                    "pid": "2479",
                    "imgPath": "2022/2479.jpg",
                    "selected": false
                },
                {
                    "pid": "2812",
                    "imgPath": "2022/2812.jpg",
                    "selected": false
                },
                {
                    "pid": "4681",
                    "imgPath": "2022/4681.jpg",
                    "selected": false
                },
                {
                    "pid": "4684",
                    "imgPath": "2022/4684.jpg",
                    "selected": false
                },
                {
                    "pid": "4785",
                    "imgPath": "2022/4785.jpg",
                    "selected": false
                },
                {
                    "pid": "4972",
                    "imgPath": "2022/4972.jpg",
                    "selected": false
                },
                {
                    "pid": "5129",
                    "imgPath": "2022/5129.jpg",
                    "selected": false
                },
                {
                    "pid": "5276",
                    "imgPath": "2022/5276.jpg",
                    "selected": false
                },
                {
                    "pid": "5277",
                    "imgPath": "2022/5277.jpg",
                    "selected": false
                },
                {
                    "pid": "5351",
                    "imgPath": "2022/5351.jpg",
                    "selected": false
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 50,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    computed:{
        /**
         * Filter images by current page and max images per page
         * @returns Array
         */
        paginatedImages() {
            let imagesUnshuffled = this.images;
            const imagesShuffled = imagesUnshuffled
                .map((value) => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value)
            return imagesShuffled.slice(0, this.currentPage * this.maxImagesPerPage);
        },

        /**
         * Check if there are another images or not
         * @returns {boolean}
         */
        numberTotal(){
            return (this.currentPage * this.maxImagesPerPage) < this.images.length
        }
    },
    methods:{
        // update page and load more images
        loadMore(){
            this.currentPage += 1;
        }
    }
}